import { getApiBaseUrl } from './apiBase';
import { getSite } from './siteConfig';

export const ENV_CONFIG = {
  get PRODUCT_NAME() {
    return process.env.REACT_APP_PRODUCT_NAME || getSite().productName || 'MineDynamicsViewer';
  },
  get PROJECT_NAME() {
    return process.env.REACT_APP_PROJECT_NAME || getSite().projectName || 'MineDynamics';
  },

  get API_BASE_URL() {
    return getApiBaseUrl();
  },

  SECURITY: {
    SESSION_TIMEOUT: parseInt(process.env.REACT_APP_SESSION_TIMEOUT) || 1800000,
    SESSION_TIMEOUT_ENABLED: process.env.REACT_APP_SESSION_TIMEOUT_ENABLED !== 'false',
    MAX_LOGIN_ATTEMPTS: parseInt(process.env.REACT_APP_MAX_LOGIN_ATTEMPTS) || 5,
    RATE_LIMIT_WINDOW: parseInt(process.env.REACT_APP_RATE_LIMIT_WINDOW) || 300000,
    PASSWORD_MIN_LENGTH: 6
  }
};
